import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown, Button, Form, Col, Row, Nav, Tab } from "react-bootstrap";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  fetchUcrtList,
  downLoadUcrtReportDatewise,
  downLoadUcrtReportInCSVDatewise
} from "../../../store/actions/ucrtsAction";
import DeleteConditionPopup from "./DeleteConditionPopup";
import ToggelActivatateConditionPopup from "./ToggelActivatateConditionPopup";
import ShowConditionUrlPopup from "./ShowConditionUrlPopup";
import ManageWard from "./ManageWard";
import { resetPopup } from "../../../store/reducerSlice/clients";
import envalope from "../../../assets/images/envalope.png";
import download from "../../../assets/images/download.png";
import black from "../../../assets/images/black.png";
import red from "../../../assets/images/red.png";
import darkYellow from "../../../assets/images/darkYellow.png";
import yellow from "../../../assets/images/yellow.png";
import greenBox from "../../../assets/images/greenBox.png";
import download2 from "../../../assets/images/download2.png";
import ucrts from "../../../store/reducerSlice/ucrts";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Loader from "../../common/loader/Loader";

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const UcrtReportList = () => {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [downloadType, setDownloadType] = useState("xlsx");
  const handleClose = () => {
    setSelectedDate(null);
    setShow(false);
    setDownloadType("xlsx");
  };
  const handleShow = () => {
    setSelectedDate(moment(new Date()).format("YYYY-MM-DD"));
    setShow(true);
  };
  const handleShow1 = () => setShow1(true);

  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState("all");
  const [selectCondition, setSelectCondition] = useState(null);
  const [selectClient, setselectClient] = useState(null);
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [searchText, setSearchText] = useState();
  const [selectedDate, setSelectedDate] = useState();

  const [activeTab, setActiveTab] = useState("");
  const searchInputRef = useRef(null);
  const [filterOption, setFilterOption] = useState({});
  const [deleteRec, setDeleteRec] = useState(null);
  const [conditionLink, setConditionLink] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [conditionLinkModalShow, setConditionLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    ucrts,
    returnList,
    updatedAt,
    filePath,
    downloadFileOfCurrentDate,
    downloadFileOfDate,
    downloadCsvFileOfDate,
    pagination,
    isLoader,
    isDownloadLoader,
    isRecordUpdated,

    error: apiError,
  } = useSelector((state) => {
    return state.ucrts;
  });
  const page = pagination?.currentPage;

  const cc =
    downloadFileOfCurrentDate || downloadFileOfDate || ucrts ;
  useEffect(() => {
    console.log("cc", cc);
    console.log("downloadFileOfCurrentDate", downloadFileOfCurrentDate);
  }, []);
  useEffect(() => {
    if (location?.state?.previousActiveTab) {
      setActiveTab(location?.state?.previousActiveTab);
      navigate(location.pathname, { replace: true });
      // dispatch(fetchUcrtList);
    }
  }, [location?.state?.previousActiveTab]);

  

  useEffect(() => {
    if (selectedDate) {
      if (downloadType === "xlsx") {
        dispatch(downLoadUcrtReportDatewise({ dateData: selectedDate }));
      } else {
        dispatch(downLoadUcrtReportInCSVDatewise({ dateData: selectedDate }));
      }
    }
  }, [selectedDate, downloadType]);
  window.history.replaceState({}, document.title);

  // useEffect(() => {
  //   if (!location?.state?.previousActiveTab) {
  //     dispatch(fetchUcrtList(filterOption));
  //   }
  // }, [filterOption, isRecordUpdated]);

  const filterStatusHandler = (obj) => {
    let val = { ...filterOption };
    val.status = obj.status;
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  // const emailReport = (e) => {
  //   dispatch(emailReportList(filterOption)).then(({ payload }) => {
  //     if (payload.success) {
  //       setIsShow(true);
  //     }
  //   });
  // };

  const hideHandle = () => {
    setModalShow(false);
    setSelectCondition(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setConditionLinkModalShow(false);
  };

  //  Report Navigate
  const navigateReport = () => {
    navigate("/ucrt-reports");
  };

  //  Ucrt Navigate
  const navigateUcrtModule = () => {
    navigate("/ucrt-module");
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };
  const downloadCurerntFile = () => {
    // alert("download");
    // window.open(
    //   downloadFileOfCurrentDate,
    //   "_blank" 
    // );
    // window.location.reload(true);
    // dispatch(downLoadUcrtReport()).then(({ payload }) => {
    //   console.log("payload",payload);
    //       if (payload.success) {
    //         setMessage(payload?.data?.message);
    //         setIsShow(true);
    //       }
    //     });
  };
  return (
    <>
      {/* Modal Download Date wise report */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise {downloadType === "xlsx" ? "Excel" : "CSV"} Report
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 px-5">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="select"
              defaultValue={moment(new Date()).format("YYYY-MM-DD")}
              max={moment(new Date()).format("YYYY-MM-DD")}
              autoFocus
              onChange={async (e) => {
                setSelectedDate(e.target.value);
              }}
            />
          </Form.Group>
          {isDownloadLoader && <Loader />}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          {downloadType === "xlsx" && downloadFileOfDate && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadFileOfDate}
              target="_blank"
            >
              <img src={download} alt="img" /> Download xlsx Report
            </a>
          )}
          {downloadType === "csv" && downloadCsvFileOfDate && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadCsvFileOfDate}
              target="_blank"
            >
              <img src={download} alt="img" /> Download CSV Report
            </a>
          )}
          {apiError && <p className="textWarning">{apiError?.message}</p>}

          <span
            className="cancel-btn mt-4 cursor-pointer"
            onClick={handleClose}
          >
            Cancel
          </span>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* {isLoader && <Loader />} */}
      <div className="container">
       
        <DeleteConditionPopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        <ShowConditionUrlPopup
          onHide={hideHandle}
          conditionLink={conditionLink}
          conditionLinkModalShow={conditionLinkModalShow}
          setConditionLinkModalShow={setConditionLinkModalShow}
        />
        <ToggelActivatateConditionPopup
          onHide={hideHandle}
          toggleActivateRec={toggleActivateRec}
          toggleActivateStatus={toggleActivateStatus}
          toggleActivateModalShow={toggleActivateModalShow}
          setToggleActivateModalShow={setToggleActivateModalShow}
        />

        <h1 className="main-title">UCRT</h1>
        <div className="block-section">
        <Button
            variant="outline-primary reportBtn me-4"
            onClick={navigateUcrtModule}
          >
            UCRT
          </Button>
          <Button
            className="btn-primary btn-primary reportBtn me-4"
            onClick={navigateReport}
          >
            Daily UCRT Reports
          </Button>
          
        </div>

        <div className="block-section">
          <p className="txtHeading">You can download the UCRT report</p>
          {cc && cc.length ? (
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-download" style={{ fontWeight: 600 }}>
                <img src={download} style={{ marginRight: "6px" }} alt="img" />
                Download Report
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    setDownloadType("xlsx");
                    handleShow();
                  }}
                >
                  Download as Excel
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setDownloadType("csv");
                    handleShow();
                  }}
                >
                  Download as CSV
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Button
              className="reportBtn1 not-allowed  disable"
              style={{ cursor: "not-allowed" }}
              disabled
            >
              <img src={download} alt="img" /> Download Date Wise UCRT Report
            </Button>
          )}
        </div>
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded: isShow,
          title: "Report",
          successMsg: message,
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default UcrtReportList;
